import useRouteName from "../../../../hooks/useRouteName.js";
const useFlyAnywhereRoute = () => {
    const routeName = useRouteName();
    return routeName === "fly-anywhere";
};
export default useFlyAnywhereRoute;
